import { Text, Grid } from '@simplywallst/ui-core';

import {
  formatCurrencyTruncatedWithSign,
  formatPercentageWithSign,
} from '@/utilities/portfolio/formatValue';
import PositiveNegativeValue from '@/components/PositiveNegativeValue';

import type { Portfolio } from '@/hooks/usePortfolio';

import { useManualPortfolioContext } from '@/components/PortfolioManual';

import { TotalValueMobile } from './components/TotalValueMobile';
import { ManualPortfolioHoldingCompletition } from './components/ManualPortfolioHoldingCompletition';

import { Summary, LineBreak } from './styled';

interface Props {
  portfolio: Portfolio;
}

export const SummaryMobile = ({ portfolio }: Props) => {
  const { updatePortfolio } = useManualPortfolioContext();
  const { analysis, currencyISO, holdings, type } = portfolio;
  return (
    <Summary as="section" templateRows="auto auto">
      <Grid templateColumns="1fr 1px 1fr">
        <Grid gap="4px" alignContent="start">
          <Text
            typography="tiny"
            textAlign="center"
            color="whiteRGBA"
            opacity={0.5}
          >
            Total Value
          </Text>
          <TotalValueMobile value={analysis.value} currencyISO={currencyISO} />
        </Grid>
        <LineBreak />
        <Grid gap="6px" alignContent="start">
          <Text
            typography="tiny"
            textAlign="center"
            color="whiteRGBA"
            opacity={0.5}
          >
            Total Returns
          </Text>
          <Grid>
            <Text typography="smallStrong" textAlign="center">
              <PositiveNegativeValue value={analysis.roiValue}>
                {formatCurrencyTruncatedWithSign(
                  analysis.roiValue,
                  currencyISO
                )}
              </PositiveNegativeValue>
            </Text>
            {analysis.roi > 0 && (
              <Text typography="smallStrong" textAlign="center">
                <PositiveNegativeValue value={analysis.roi}>
                  {formatPercentageWithSign(analysis.roi)}
                </PositiveNegativeValue>
              </Text>
            )}
          </Grid>
        </Grid>
      </Grid>
      {type === 'manual' && (
        <ManualPortfolioHoldingCompletition
          holdings={holdings}
          onClick={() => updatePortfolio({ portfolioId: portfolio.id })}
        />
      )}
    </Summary>
  );
};
